<template>
  <div id="about-view">
    <div class="mobile-header" v-if="isMobile">
      <div class="toggle-button hambuger-icon" v-on:click="openMenu" v-if="isMobile">☰</div>
    </div>
    <div class="desktop-header" v-else>
      <nav-header></nav-header>
    </div>
    <div class="about-container">
      <div class="logo-container"></div>
      <div class="text-container">
        <div v-html="$t('about.par1')"></div>
      </div>
      <div class="credits-container">
         <div class="logo-d4c"><img src="~@/../static/logo/D4C_Black.svg"></div>
         <div class="logo-us"><img src="~@/../static/logo/USAID_Arabic.jpg"></div>
         <div class="logo-irkchf"><img src="~@/../static/logo/IRCKHF-Logo.jpg"></div>
         <div class="logo-fhi"><img src="~@/../static/logo/FHI360.png"></div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavHeader from "../components/NavHeader";

  export default {
    name: "about",
    components: {
      NavHeader,
    },
    computed: {
      isMobile(){
        return this.$store.state.isMobile
      }
    },
    methods: {
      openMenu(event){
        this.$emit('openMenu')
        event.stopPropagation();
      }
    }
  }
</script>

<style lang="stylus" scoped>

#about-view
  min-height: 100vh;
  max-height: 100vh;
  display flex
  flex-direction column
  .mobile-header
    padding-bottom: 50px
    height 35px
    width 90%
    margin-left 5%
    display flex
    flex-direction row
    .toggle-button
      margin-left: auto;
      font-size: 30px;
      margin-top: 10px;

  .about-container
    display flex
    flex-direction column
    align-items center
    width 100%
    margin-top: 10px;
  .logo-container
    min-height: 50px;
    width: 100%;
    margin-bottom: 25px
    background: url('~@/../static/images/logo-black.svg') no-repeat center center;

  .text-container
    width 70%
    text-align left 
    font-size 14px
    font-weight 200
    margin-bottom 40px
    span
      display block
      margin-bottom 15px

  .credits-container  
    width 70%
    text-align center
    margin-bottom 20px

    img 
      height 60px
      margin-top 15px
      margin-bottom 15px

.ar #about-view
 .text-container, .logo-container
    margin-right 25px
    text-align right 
@media only screen and (min-width: 768px)
  #about-view 
   .logo-container
      background-position left center
   .about-container
      margin-top 40px
      width 80%
      margin-left 10%
      display flex
      flex-direction column
      align-items: flex-start
      .text-container
        width 60%
    .credits-container  
      width 100%
      display: flex
      margin-bottom 20px
      img 
        margin 15px

.ar #about-view
  .logo-container
    background-position right center
  .about-container
    align-items flex-end
  .credits-container
    align-items center
    justify-content flex-end
</style>



// WEBPACK FOOTER //
// src/views/About.vue